/* eslint-disable @typescript-eslint/naming-convention */
import { LocaleId } from "@hermes/locale";

interface TranslationModule {
    translations: Record<string, string>;
}

/**
 * Explicit mapping of locale IDs to their lazy-loaded translation modules.
 *
 * This replaces the webpack "context module" pattern (`import(\`./i18n/${localeId}\`)`),
 * which is not supported by esbuild. Each entry uses a static string in `import()`,
 * allowing esbuild to resolve and code-split these modules correctly.
 */
export const I18N_LOADER_MAP: Record<string, () => Promise<TranslationModule>> =
    {
        "de-AT": () => import("./i18n/de-AT"),
        "de-CH": () => import("./i18n/de-CH"),
        de: () => import("./i18n/de"),
        "en-AE": () => import("./i18n/en-AE"),
        "en-AU": () => import("./i18n/en-AU"),
        "en-BE": () => import("./i18n/en-BE"),
        "en-CA": () => import("./i18n/en-CA"),
        "en-CN": () => import("./i18n/en-CN"),
        "en-CZ": () => import("./i18n/en-CZ"),
        "en-DK": () => import("./i18n/en-DK"),
        "en-FI": () => import("./i18n/en-FI"),
        "en-GB": () => import("./i18n/en-GB"),
        "en-GR": () => import("./i18n/en-GR"),
        "en-HK": () => import("./i18n/en-HK"),
        "en-IE": () => import("./i18n/en-IE"),
        "en-MO": () => import("./i18n/en-MO"),
        "en-MY": () => import("./i18n/en-MY"),
        "en-NL": () => import("./i18n/en-NL"),
        "en-NO": () => import("./i18n/en-NO"),
        "en-PL": () => import("./i18n/en-PL"),
        "en-PT": () => import("./i18n/en-PT"),
        "en-SA": () => import("./i18n/en-SA"),
        "en-SE": () => import("./i18n/en-SE"),
        "en-SG": () => import("./i18n/en-SG"),
        "en-TH": () => import("./i18n/en-TH"),
        en: () => import("./i18n/en"),
        "es-MX": () => import("./i18n/es-MX"),
        es: () => import("./i18n/es"),
        "fr-BE": () => import("./i18n/fr-BE"),
        "fr-CA": () => import("./i18n/fr-CA"),
        "fr-CH": () => import("./i18n/fr-CH"),
        "fr-LU": () => import("./i18n/fr-LU"),
        fr: () => import("./i18n/fr"),
        it: () => import("./i18n/it"),
        ja: () => import("./i18n/ja"),
        ko: () => import("./i18n/ko"),
        pt: () => import("./i18n/pt"),
        "zh-Hans": () => import("./i18n/zh-Hans"),
        "zh-Hant": () => import("./i18n/zh-Hant"),
    };

export function loadTranslationModule(
    localeId: LocaleId,
): Promise<TranslationModule> {
    const loader = I18N_LOADER_MAP[localeId];
    if (!loader) {
        return Promise.reject(
            new Error(`No translation module found for locale: ${localeId}`),
        );
    }
    return loader();
}
